import type { IconProps } from '../../types/global.types';

const SearchIcon = ({ size }: IconProps) => {
  return (
    <svg
      width={size||"10"}
      height={size||"10"}
      viewBox="0 0 10 10"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M4 0C1.79086 0 0 1.79086 0 4C0 6.20914 1.79086 8 4 8C4.92417 8 5.77513 7.68659 6.45241 7.16025L9.14551 9.85335C9.34077 10.0486 9.65735 10.0486 9.85261 9.85335C10.0479 9.65808 10.0479 9.3415 9.85261 9.14624L7.15961 6.45323C7.68633 5.77583 8 4.92454 8 4C8 1.79086 6.20914 0 4 0ZM1 4C1 2.34315 2.34315 1 4 1C5.65685 1 7 2.34315 7 4C7 5.65685 5.65685 7 4 7C2.34315 7 1 5.65685 1 4Z"
        fill="currentColor"
      />
    </svg>
  );
};

export default SearchIcon;
